export default function setupAxios(axios: any, store: any) {
  let isRefreshing = false
  let failedQueue: any[] = []

  const processQueue = (error: any, token: string | null = null) => {
    failedQueue.forEach(prom => {
      if (error) prom.reject(error)
      else prom.resolve(token)
    })
    failedQueue = []
  }

  // 🔹 Token'ı her isteğe ekle
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {accessToken},
      } = store.getState()

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  // 🔹 Token expired olduğunda yakala
  axios.interceptors.response.use(
    (response: any) => response,
    async (error: any) => {
      const originalRequest = error.config
      const status = error.response?.status

      if (status === 401 && !originalRequest._retry) {
        const refreshToken = localStorage.getItem('refreshToken')

        // Refresh token yoksa → logout
        if (!refreshToken) {
          store.dispatch({type: '[Logout] Action'})
          localStorage.removeItem('accessToken')
          localStorage.removeItem('refreshToken')
          window.location.href = '/login'
          return Promise.reject(error)
        }

        if (isRefreshing) {
          // Eğer başka istekler bekliyorsa
          return new Promise(function (resolve, reject) {
            failedQueue.push({resolve, reject})
          })
            .then((token) => {
              originalRequest.headers.Authorization = 'Bearer ' + token
              return axios(originalRequest)
            })
            .catch((err) => Promise.reject(err))
        }

        originalRequest._retry = true
        isRefreshing = true

        try {
          // 🔸 Refresh token ile yeni access token iste
          const {data} = await axios.post(`${process.env.REACT_APP_API_URL}api/v1/auth/refresh`, {
            refreshToken,
          })

          const newAccessToken = data?.accessToken
          const newRefreshToken = data?.refreshToken

          if (!newAccessToken) throw new Error('Invalid refresh token')

          // 🔸 Yeni token’ları kaydet
          localStorage.setItem('accessToken', newAccessToken)
          if (newRefreshToken) localStorage.setItem('refreshToken', newRefreshToken)

          // 🔸 Redux store’a güncel token gönder
          store.dispatch({
            type: '[Login] Action',
            payload: {accessToken: newAccessToken},
          })

          // 🔸 Axios default header’ı güncelle
          axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`

          processQueue(null, newAccessToken)

          // 🔸 Orijinal isteği tekrar gönder
          return axios(originalRequest)
        } catch (err) {
          processQueue(err, null)
          store.dispatch({type: '[Logout] Action'})
          localStorage.removeItem('accessToken')
          localStorage.removeItem('refreshToken')
          window.location.href = '/login'
          return Promise.reject(err)
        } finally {
          isRefreshing = false
        }
      }

      return Promise.reject(error)
    }
  )
}
